<template>
	<div class="content-box">
		<div class="operator">
			<div class="operator-col">
				<hispickup v-model="filterHisDate"></hispickup>
			</div>
			<div class="operator-col">
				<product-input :params="{allowCreate: false,placeholder:'SPU 名/码'}" v-model="filterProducts"></product-input>
			</div>
		</div>
		<sum-table
			ref="sumTable"
			:data-model="editorDataModel"
			:search-filter="filterTableSearch"
			:kv-filter="kvFilter"
			:fields="sumFields"
			list-url="orderm/sums/due"
		></sum-table>
		<curd-table
			ref="listTable"
			:data-model="editorDataModel"
			:list-ops="listOps"
			:has-op-slot="true"
			:fields="tableFields"
			:has-delete="false"
			list-url="orderm/lists/due"
			:search-filter="filterTableSearch"
			:date-filter="filterHisDate"
			:kv-filter="kvFilter"
			:has-expand-show="true"
		>
			<template slot="expandShow" slot-scope="scope">
				<div class="row">
					<div class="col-md-6">
						<h5>备注</h5>
						<p>{{scope.row.desc}}</p>
					</div>
					<div class="col-md-6">
						<h5>单据/截图</h5>
						<p>
							<img :src="scope.row.primary_img" class="img-fluid order-img" />
						</p>
					</div>
				</div>
				<table class="table table-bordered">
					<tr v-for="tx_item in scope.row.order_items" :key="tx_item._id">
						<td v-for="(key,index) in itemTableFields" :key="index">
							<field-show
								:field-info="dataModels.Order_item[key.name]"
								:value="tx_item[key.name]"
								:field-key="key"
							></field-show>
						</td>
					</tr>
				</table>
			</template>
			<template slot="listOp" slot-scope="scope">
				<el-button size="mini" type="text" @click="goInfo(scope.row._id)">详情</el-button>
				<el-button
					size="mini"
					type="text"
					@click="goCheckTx(scope.row._id)"
					v-if="scope.row.status.index==10"
				>派单</el-button>
				<el-button
					size="mini"
					type="text"
					@click="doDeleteOrder(scope.row._id)"
					v-if="scope.row.status.index==10"
				>删除</el-button>
				<el-button
					size="mini"
					type="text"
					@click="doRejectOrder(scope.row._id)"
					v-if="scope.row.status.index==11"
				>打回</el-button>

				<el-button
					size="mini"
					type="text"
					@click="doHasPayed(scope.row._id)"
					v-if="!scope.row.has_payed"
				>已收款</el-button>
			</template>
		</curd-table>
		<pay-editor
			:show.sync="payEditorVisible"
			:record-id="payEditorId"
			@change="refreshTable('listTable')"
			v-if="payEditorVisible"
		></pay-editor>
	</div>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterProducts from "@/mixins/Filter/FilterProducts.js";

import OrderOp from "@/mixinsApp/OrderOp.js";
import LoadDM from "@/mixins/LoadDM.js";
import { RenderOrderLists, RenderSaler } from "@/mixinsApp/Render.js";

export default {
	mixins: [CurdPage, Filters, FilterProducts, OrderOp, LoadDM],
	data() {
		return {
			editorDataModel: "Order",
			dataModelNames: ["Order", "Order_item"],
			listOps: [
				{
					name: "info",
					show_name: "详情",
					handler: "goinfo",
				},
			],
			tableFields: [
				{
					name: "show_id",
					sortable: "custom",
					isBold: true,
					needThumb: "primary_img",
				},
				{
					name: "customer",
					sortable: "custom",
					isTag: true,
					width: "90px",
				},
				{
					name: "express_type",
					render: info => {
						return "[" + info.express_type.name + "] " + info.address.name;
					},
					width: "80px",
				},
				{
					name: "saler",
					render: RenderSaler,
				},
				{
					name: "name",
					width: "250px",
					params: {
						multiHidden: true,
					},
					render: RenderOrderLists,
				},
				{
					name: "total_price",
					sortable: "custom",
					isTag: true,
				},
				{
					name: "created_at",
					sortable: "custom",
				},
				{
					name: "status",
					sortable: "custom",
					width: "80",
				},
			],
			editorFields: [
				{
					name: "name",
					rules: ["required"],
					width: "100%",
				},
				{
					name: "is_focus",
					width: "100%",
				},
				{
					name: "main_supplier",
				},
				{
					name: "intro",
					width: "100%",
				},
			],
		};
	},

	methods: {},
};
</script>
<style lang="scss" scoped>
</style>
